import React from 'react';
import {space} from 'styled-system';
import styled, {useTheme} from 'styled-components';
import {whereVariant} from '../../utils/index';
import IdeaIcon from './icons/IdeaIcon';
import AdminInboxIcon from './icons/AdminInboxIcon';
import AnonymousIcon from './icons/AnonymousIcon';
import AddMessageIcon from './icons/AddMessageIcon';

const Android = () => (
  <path
    d="M8.4 3l1.35 1.35M15.6 3l-1.35 1.35M16.4 18.3H7.6a1 1 0 0 1-1-1v-8h10.8v8a1 1 0 0 1-1 1zM17.4 9.3a5.4 5.4 0 0 0-10.8 0M20 9.25v5.5M4 9.25v5.5M9.3 18.3V21M14.7 18.3V21"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);

const Apple = () => (
  <path
    d="M11.592 9.168c-.656 0-1.678-.764-2.74-.764-1.412 0-2.704.863-3.432 2.129-1.464 2.542-.377 6.298 1.051 8.364.701 1.006 1.527 2.138 2.623 2.102 1.051-.045 1.446-.683 2.722-.683 1.267 0 1.626.683 2.74.656 1.132-.018 1.851-1.024 2.542-2.039a9.014 9.014 0 0 0 1.15-2.363c-.027-.009-2.201-.844-2.228-3.36-.018-2.102 1.716-3.108 1.797-3.153-.988-1.446-2.506-1.608-3.036-1.644-1.384-.108-2.542.755-3.189.755zM13.651 2.955c.87-.324 1.438.153 1.27 1.065-.168.912-1.008 1.913-1.877 2.237-.87.324-1.438-.153-1.27-1.065.168-.912 1.008-1.914 1.877-2.237z"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);

const ArrowBackUp = () => (
  <>
    <path d="M9.048 4v11c0 2.75 2.198 5 4.885 5h-.03 5.145" />
    <path d="M13.096 8.048L9.048 4 5 8.048" />
  </>
);

const ArrowLeft = () => <path d="M16 4l-8 8 8 8" />;

const Bin = () => (
  <path d="M16.138 21h-8.28a2 2 0 0 1-1.995-1.853L4.966 7H19l-.867 12.142A2 2 0 0 1 16.138 21zM12 11v6M4 7h16M17 7l-1.013-2.702A2 2 0 0 0 14.114 3H9.886a2 2 0 0 0-1.873 1.298L7 7M15.429 11L15 17M8.571 11L9 17" />
);

const Bookmark = () => (
  <path d="M7.7 3h8.6a2 2 0 0 1 2 2v16l-6.292-3.273L5.7 21V5a2 2 0 0 1 2-2z" />
);

const Box = () => (
  <>
    <path d="M20.926 15.999V8.001c0-.715-.381-1.375-1-1.732L13 2.27a2 2 0 00-2 0L4.074 6.269a2 2 0 00-1 1.732v7.997c0 .715.381 1.375 1 1.732l6.926 4a2.002 2.002 0 002 0l6.926-3.999a2 2 0 001-1.732v0z" />
    <path d="M6.17 12.63l3 1.74M3.342 7.001L12 12l8.658-4.999M12 22V12M7.67 9.5l8.93-5.15" />
  </>
);

const Calendar = () => (
  <>
    <path d="M16 2v4M8 2v4M3 9h18M19 4H5a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2v0ZM7 13h10M7 17h5" />
    <path d="M16 21v-3a1 1 0 0 1 1-1h4" />
  </>
);

const CalendarAdd = () => (
  <>
    <path d="M15 3v2M7 3v2M3 8h16M19 12.417V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h7.417" />
    <path d="M6.997 10.25a.75.75 0 1 0 .006 1.5.75.75 0 0 0-.006-1.5zM6.997 14.25a.75.75 0 1 0 .006 1.5.75.75 0 0 0-.006-1.5zM10.25 11.003a.75.75 0 1 0 1.5-.006.75.75 0 0 0-1.5.006z" />
    <path d="M17 22a5 5 0 0 1-5-5c0-2.704 2.3-5.003 5.004-5A5 5 0 1 1 17 22z" />
    <path d="M17 15v4M19 17h-4" />
  </>
);

const Chat = () => (
  <path d="M21 11.291c0 4.539-4.048 8.182-9 8.182-.627 0-1.253-.06-1.869-.179M6.599 17.826C4.42 16.336 3 13.974 3 11.291M6.599 17.826c-.001.854.001 2.006.001 3.215M3 11.141c0-4.539 4.048-8.182 9-8.182s9 3.643 9 8.182M10.131 19.294L6.6 21.041" />
);

// this is a fist
// const Cheer = () => (
//   <>
//     <path d="M6.077 9.462v-3.59c0-.476.17-.933.473-1.27a1.538 1.538 0 0 1 1.142-.525c.429 0 .84.189 1.143.526a1.9 1.9 0 0 1 .473 1.269" />
//     <path d="M9.308 9.462V4.615a1.615 1.615 0 0 1 3.23 0" />
//     <path d="M15.77 6.77c0-.43.149-.84.414-1.143.266-.303.825-.473 1.2-.473.376 0 .935.17 1.2.473.267.303.416.714.416 1.142v7c0 1.714-.597 3.357-1.66 4.57-1.063 1.211-2.505 1.892-4.008 1.892h-2.677c-1.358 0-2.67-.556-3.7-1.566-1.028-1.01-1.705-2.407-1.906-3.937-.035-1.497-.508-5.266 2.402-5.266h5.593s2.725-.077 2.725 1.242c0 1.32-2.496 2.566-3.769 2.566H9.737s2.835-.578 3.307 3.73M19 9.462a1.616 1.616 0 0 1-3.23 0" />
//     <path d="M12.539 9.185V4.546c0-.853.723-1.546 1.615-1.546s1.615.693 1.615 1.546v5.416" />
//   </>
// );
const Cheer = () => (
  <>
    <path d="m17.87,13.99c.61,1.2.54,1.57-.39,2.54-.16.16-.24.43-.28.67-.2,1.29-.57,1.67-1.88,1.79-2.67.26-5.33.1-7.99-.2-.5-.06-1.01-.14-1.51-.17-.45-.02-.65-.22-.65-.67,0-2.5-.02-5,0-7.5,0-.19.22-.4.37-.57.28-.3.69-.52.86-.87.72-1.47,1.74-2.68,3.06-3.59,1.23-.84,1.88-1.9,1.87-3.39,0-.54.24-.94.78-1.1.64-.2,1.11,0,1.42.62.49,1.01.52,2.04.08,3.07-.33.78-.7,1.54-1.02,2.32-.29.7-.11.92.64.95,1.25.03,2.51-.04,3.73.13,1.54.21,2.01,1.26,1.41,2.7-.1.24-.16.59-.06.8.61,1.29.61,1.4-.43,2.45Z" />
    <path d="m1.29,14.28c0-1.25.01-2.5,0-3.75,0-.46.16-.66.62-.65.72.02,1.44.01,2.16,0,.4,0,.57.16.57.57,0,2.56,0,5.13,0,7.69,0,.39-.13.6-.55.59-.74-.01-1.48-.01-2.22,0-.45,0-.58-.22-.58-.63.01-1.27,0-2.54,0-3.81Z" />
  </>
);
const ChevronLeft = () => <path d="M14 7l-5 5 5 5" />;

const ChevronLeftLarge = () => <path d="M16 4l-8 8 8 8" />;

const Clock = () => (
  <>
    <path d="M16.641 16l-4.922-2.936V6.736" />
    <path d="M18.364 5.636A9 9 0 1 1 5.635 18.365 9 9 0 0 1 18.364 5.636" />
  </>
);

const ChevronRight = () => <path d="M9 17l5-5-5-5" />;

const Comments = () => (
  <>
    <path d="M16.333 3H4.667C3.746 3 3 3.746 3 4.667V13" />
    <path d="M13.5 21l1.667-3.333h4.167c.92 0 1.666-.747 1.666-1.667V7.667C21 6.746 20.254 6 19.333 6H7.667C6.746 6 6 6.746 6 7.667V16c0 .92.746 1.667 1.667 1.667H11M10 10h7M10 14h4" />
  </>
);

const Cross = () => <path d="M6 6l12 12M18 6L6 18" />;

const Document = () => (
  <g>
    <path
      d="M18.414 6.414L15.586 3.586C15.211 3.2109 14.7024 3.00011 14.172 3H7C6.46957 3 5.96086 3.21071 5.58579 3.58579C5.21071 3.96086 5 4.46957 5 5V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V7.828C18.9999 7.29761 18.7891 6.78899 18.414 6.414V6.414Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 8H15C14.7348 8 14.4804 7.89464 14.2929 7.70711C14.1054 7.51957 14 7.26522 14 7V3"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 11H14"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 14H14"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 17H12.333"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </g>
);

const Download = () => (
  <path d="M12 15.111V5M19 15.889A3.111 3.111 0 0115.889 19H8.11A3.111 3.111 0 015 15.889M8.11 12L12 15.89M15.889 12l-3.89 3.89" />
);

const Email = () => (
  <>
    <path d="M19 18.981H5a2 2 0 01-2-2V7.019a2 2 0 012-2h14a2 2 0 012 2v9.963a2 2 0 01-2 1.999v0z" />
    <path d="M17 9l-5 3-5-3" />
  </>
);

const Error = () => (
  <>
    <path d="M12 12V7.5" />
    <path d="M11.625 15.877a.375.375 0 10.75-.004.375.375 0 00-.75.004" />
    <path d="M3 14.381V9.619A4.5 4.5 0 015.236 5.73l4.5-2.619a4.5 4.5 0 014.527 0l4.5 2.619A4.5 4.5 0 0121 9.619v4.762a4.5 4.5 0 01-2.236 3.889l-4.5 2.619a4.5 4.5 0 01-4.527 0l-4.5-2.619A4.5 4.5 0 013 14.381v0z" />
  </>
);

const Folder = () => (
  <path d="M19 6.94h-6.471a1 1 0 01-.827-.438l-1.405-2.065A1 1 0 009.471 4H5a2 2 0 00-2 2v12a2 2 0 002 2h14a2 2 0 002-2V8.94a2 2 0 00-2-2v0z" />
);

const Folders = () => (
  <>
    <path d="M19 9h-6.471a1 1 0 01-.827-.438l-1.405-2.065a1 1 0 00-.826-.437H5a2 2 0 00-2 2V19a2 2 0 002 2h14a2 2 0 002-2v-8a2 2 0 00-2-2z" />
    <path d="M21 19v-8a2 2 0 00-2-2h-6.471a1 1 0 01-.827-.438l-1.405-2.065a1 1 0 00-.826-.437H5a2 2 0 00-2 2V19M19 5.94h-4.471a1 1 0 01-.827-.438l-1.405-2.065A1 1 0 0011.471 3H5" />
  </>
);

const Home = () => (
  <>
    <path d="M13 13h-2a2 2 0 0 0-2 2v6h6v-6a2 2 0 0 0-2-2z" />
    <path d="M4 9.632L12 3l8 6.632V21H4V9.632z" />
  </>
);

const Image = () => (
  <>
    <path d="M18.353 19.615H5.693a2 2 0 01-2-2v-11a2 2 0 012-2h12.66a2 2 0 012 2v11a2 2 0 01-2 2z" />
    <path d="M8.69 11.282a1.667 1.667 0 100-3.334 1.667 1.667 0 000 3.334zM20.353 15.446L16.97 12.74a1 1 0 00-1.406.156l-2.572 3.215a1 1 0 01-1.406.156l-1.299-1.039a1 1 0 00-1.393.141l-3.513 4.216" />
  </>
);

const Info = () => (
  <>
    <path d="M11.997 7.25a.75.75 0 10.006 1.5.75.75 0 00-.006-1.5z" />
    <path d="M12 21a9 9 0 110-18 9 9 0 010 18v0zM12 12v5" />
  </>
);

const Link = () => (
  <>
    <path d="m10 13 .953.953a3.998 3.998 0 0 0 5.657 0l3.031-3.031a4.641 4.641 0 0 0-6.563-6.563l-.887.888" />
    <path d="m14 10-.953-.953a4 4 0 0 0-5.657 0l-3.031 3.031a4.64 4.64 0 0 0 6.563 6.563l.887-.888" />
  </>
);

const Magnifier = () => (
  <>
    <path d="M19.5 19.286l-4.758-4.758" />
    <path d="M10.5 16.286a6 6 0 100-12 6 6 0 000 12z" />
  </>
);

const Marker = () => (
  <>
    <path d="M5.127 10.045v-.172a6.873 6.873 0 0 1 13.746 0v.172c0 3.461-4.382 8.671-6.148 10.631a.973.973 0 0 1-1.45 0c-1.766-1.96-6.148-7.17-6.148-10.631z" />
    <path d="M10 9.955a2 2 0 0 0 4 0v-.037a2 2 0 1 0-4 0" />
  </>
);

const MenuDots = () => (
  <path d="M11.625 12.001a.375.375 0 1 0 .75-.004.375.375 0 0 0-.75.004M11.625 6.001a.375.375 0 1 0 .75-.004.375.375 0 0 0-.75.004M11.625 18.001a.375.375 0 1 0 .75-.004.375.375 0 0 0-.75.004" />
);

const Microsoft = () => (
  <>
    <path fill="#f35325" d="M1 1h10v10H1z" />
    <path fill="#81bc06" d="M12 1h10v10H12z" />
    <path fill="#05a6f0" d="M1 12h10v10H1z" />
    <path fill="#ffba08" d="M12 12h10v10H12z" />
  </>
);

const MobilePhone = () => (
  <>
    <path d="M16 21H8a2 2 0 01-2-2V5a2 2 0 012-2h8a2 2 0 012 2v14a2 2 0 01-2 2v0z" />
    <path d="M11.997 17.25a.75.75 0 10.006 1.5.75.75 0 00-.006-1.5z" />
    <path d="M10.75 6h2.5" />
  </>
);

const NoSearch = () => (
  <>
    <path d="M11.467 18.934a7.467 7.467 0 110-14.934 7.467 7.467 0 010 14.934v0z" />
    <path d="M11.467 12.504v-.207c0-.678.419-1.045.839-1.327.41-.276.821-.636.821-1.3a1.66 1.66 0 00-3.319-.001M11.466 14.843a.149.149 0 00-.124.233.15.15 0 10.124-.233M20 20l-3.253-3.253" />
  </>
);

const Pen = () => (
  <path d="M17.54 10.12l-3.66-3.66M6.251 21H3v-3.251c0-.265.105-.52.293-.707L16.627 3.707a1 1 0 011.414 0l2.251 2.251a1 1 0 010 1.414L6.958 20.707a.996.996 0 01-.707.293v0z" />
);

const Phone = () => (
  <path d="M10.856 13.1439C9.74937 12.0477 8.855 10.7564 8.21799 9.33494C8.1594 9.19636 8.1439 9.04336 8.17351 8.89585C8.20312 8.74834 8.27647 8.61317 8.38399 8.50794L9.20299 7.68994C9.87399 7.01894 9.87399 6.06994 9.28799 5.48394L8.11399 4.30994C7.73894 3.935 7.23032 3.72437 6.69999 3.72437C6.16966 3.72437 5.66105 3.935 5.28599 4.30994L4.63399 4.96194C3.89299 5.70294 3.58399 6.77194 3.78399 7.83194C4.27799 10.4449 5.79599 13.3059 8.24499 15.7549C10.694 18.2039 13.555 19.7219 16.168 20.2159C17.228 20.4159 18.297 20.1069 19.038 19.3659L19.689 18.7149C20.0639 18.3399 20.2746 17.8313 20.2746 17.3009C20.2746 16.7706 20.0639 16.262 19.689 15.8869L18.516 14.7139C18.2347 14.4327 17.8532 14.2748 17.4555 14.2748C17.0577 14.2748 16.6763 14.4327 16.395 14.7139L15.492 15.6179C15.3868 15.7255 15.2516 15.7988 15.1041 15.8284C14.9566 15.858 14.8036 15.8425 14.665 15.7839C13.2437 15.1458 11.9524 14.2508 10.856 13.1439V13.1439Z" />
);

const Privacy = () => (
  <>
    <path d="M8 4l1.3-1.625A1 1 0 0110.081 2h3.839a1 1 0 01.781.375L16 4v1a1 1 0 01-1 1H9a1 1 0 01-1-1V4zM9.667 9.333L8 11l-1-1M10 18h6M13 10h3M10 14h6" />
    <path d="M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2" />
  </>
);

const Play = () => (
  <path d="M15.643 11.302L9.012 7.098C8.556 6.81 8 7.193 8 7.796v8.407c0 .604.556.987 1.012.698l6.631-4.204c.476-.3.476-1.094 0-1.395z" />
);

const Settings = () => (
  <>
    <path d="M13.91 10.09a2.701 2.701 0 11-3.82 3.82 2.701 2.701 0 013.82-3.82" />
    <path d="M5.25 12c0 .297.027.594.063.882l-1.588 1.242a.898.898 0 00-.224 1.156l1.412 2.443a.898.898 0 001.112.384l1.422-.571a.911.911 0 01.846.099c.22.146.448.28.684.4.27.137.466.382.509.682l.217 1.513c.063.442.442.77.888.77h2.817a.897.897 0 00.888-.77l.217-1.512a.917.917 0 01.512-.683c.235-.118.462-.251.681-.396a.914.914 0 01.85-.102l1.419.57a.898.898 0 001.112-.384l1.412-2.443a.898.898 0 00-.224-1.156l-1.588-1.242c.036-.288.063-.585.063-.882 0-.297-.027-.594-.063-.882l1.588-1.242a.898.898 0 00.224-1.156l-1.412-2.443a.898.898 0 00-1.112-.384l-1.419.57a.918.918 0 01-.85-.102 6.595 6.595 0 00-.681-.396.918.918 0 01-.512-.683l-.216-1.512a.897.897 0 00-.888-.77h-2.817a.897.897 0 00-.888.77l-.218 1.514a.92.92 0 01-.509.682c-.236.12-.464.255-.684.4a.917.917 0 01-.847.098l-1.421-.571a.898.898 0 00-1.112.384L3.501 8.72a.898.898 0 00.224 1.156l1.588 1.242A7.14 7.14 0 005.25 12v0z" />
  </>
);

const Star = () => (
  <path d="M12 2.896l2.935 5.993 6.565.967-4.75 4.662 1.121 6.586L12 17.993l-5.871 3.111 1.121-6.586L2.5 9.856l6.564-.967L12 2.896z" />
);

const Success = () => (
  <>
    <path d="M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18z" />
    <path d="M16 10l-5 5-3-3" />
  </>
);

const Tools = () => (
  <>
    <path d="m11.835 15 5 5a2.122 2.122 0 0 0 3-3l-5-5" />
    <path d="M20.916 5.847a.19.19 0 0 1 .051.085c.47 1.567.106 3.33-1.132 4.568-1.251 1.251-3.038 1.609-4.617 1.117l-8.347 8.347c-.813.813-2.139.874-2.98.09A2.122 2.122 0 0 1 3.835 17l8.383-8.383c-.492-1.579-.134-3.366 1.117-4.617 1.238-1.238 3.001-1.602 4.568-1.132a.2.2 0 0 1 .085.051l.162.162a.199.199 0 0 1 0 .283L15.515 6l2.32 2.32 2.636-2.636a.2.2 0 0 1 .283 0l.162.163ZM2.933 4.293l.674 2.023A1 1 0 0 0 4.556 7h2.279V4.721a1 1 0 0 0-.684-.949l-2.023-.674a.5.5 0 0 0-.512.121l-.562.562a.5.5 0 0 0-.121.512v0ZM6.84 7l3.5 3.5" />
  </>
);

const User = () => (
  <>
    <path d="M5 20a4.447 4.447 0 014.447-4.447h5.106A4.447 4.447 0 0119 20" />
    <path d="M15.005 5.245a4.25 4.25 0 11-5.94 6.08 4.25 4.25 0 015.94-6.08" />
  </>
);

const Users = () => (
  <path d="M12 15.222a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM7.331 19.778c1.167-.934 2.879-1.556 4.669-1.556 1.79 0 3.502.623 4.669 1.556M17.486 9.222a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM18 12.222c1.533 0 3 .533 4 1.333M6.514 9.222a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM2 13.555c1-.8 2.467-1.333 4-1.333" />
);

const WhatsApp = () => (
  <>
    <path d="M18.204 5.762a8.665 8.665 0 00-6.167-2.556c-4.807 0-8.718 3.909-8.719 8.714a8.7 8.7 0 001.163 4.357l-1.237 4.516 4.622-1.212a8.717 8.717 0 004.167 1.061h.004c4.805 0 8.716-3.91 8.718-8.715a8.66 8.66 0 00-2.551-6.165z" />
    <path d="M13.095 13.56l.406-.403c.373-.37.963-.417 1.393-.115.416.292.792.554 1.142.798.556.386.623 1.178.144 1.656l-.359.359M8.145 8.179l.359-.359a1.083 1.083 0 011.656.144c.243.35.505.726.798 1.142a1.09 1.09 0 01-.115 1.393l-.403.406M15.821 15.855c-1.481 1.474-3.97.222-5.935-1.744M9.888 14.114C7.923 12.148 6.671 9.66 8.145 8.179" />
    <path d="M10.44 10.905c.342.53.741 1.02 1.19 1.463l.002.002c.462.462.96.871 1.463 1.19" />
  </>
);

const Inbox = () => (
  <>
    <path d="M8.75 4.528H7.002c-.903 0-1.712.554-2.029 1.391L2.526 12.37c-.182.48-.276.99-.276 1.505v3.51c0 1.183.97 2.143 2.167 2.143h15.167c1.197 0 2.167-.959 2.167-2.143v-3.509c0-.514-.093-1.024-.276-1.505l-2.447-6.453a2.166 2.166 0 0 0-2.029-1.391l-8.249.001" />
    <path d="M2.322 13.099h4.674c.41 0 .786.229.969.592l.485.959c.184.363.559.593.97.593h5.161c.41 0 .785-.229.968-.592l.485-.958c.184-.363.559-.593.97-.593h4.675" />
  </>
);

const Upload = () => (
  <>
    <path d="M12 19v-7M9.833 14L12 11.833 14.167 14" />
    <path d="M16 19h2.56c1.928 0 3.5-1.572 3.5-3.5s-1.572-3.5-3.5-3.5h-.435v-1c0-3.31-2.69-6-6-6-2.977 0-5.445 2.178-5.913 5.023-2.377.121-4.272 2.07-4.272 4.477a4.5 4.5 0 004.5 4.5H8" />
  </>
);

const Pdf = () => (
  <path
    fill="currentColor"
    transform="translate(4.000000, 0.000000)"
    d="M16.0064054,4.56307145 L12.3758636,0.656523545 C11.9864133,0.237465963 11.4584919,0 10.9089343,0 L2.07706801,0 C0.930353382,0.00465619535 0,1.0057382 0,2.23962997 L0,21.6094026 C0,22.8432944 0.930353382,23.8443764 2.07706801,23.8443764 L14.5394761,23.8443764 C15.6861907,23.8443764 16.6165441,22.8432944 16.6165441,21.6094026 L16.6165441,6.14617787 C16.6165441,5.55484106 16.3958556,4.98212903 16.0064054,4.56307145 Z M15.0284525,5.62002779 C15.1193243,5.7178079 15.1799054,5.83421278 15.210196,5.96458625 L11.0776961,5.96458625 L11.0776961,1.51791969 C11.1988584,1.55051305 11.307039,1.61569979 11.3979107,1.71347989 L15.0284525,5.62002779 Z M14.5394761,22.3543939 L2.07706801,22.3543939 C1.69627221,22.3543939 1.38471201,22.0191478 1.38471201,21.6094026 L1.38471201,2.23962997 C1.38471201,1.82988477 1.69627221,1.49463871 2.07706801,1.49463871 L9.69298407,1.49463871 L9.69298407,6.33708188 C9.69298407,6.95635586 10.1559971,7.45456876 10.7315181,7.45456876 L15.2318321,7.45456876 L15.2318321,21.6094026 C15.2318321,22.0191478 14.9202719,22.3543939 14.5394761,22.3543939 Z M13.5874866,14.3829875 C13.0033112,13.7637135 11.2075128,13.9546175 10.3983217,14.0710224 C9.48095004,13.4750294 8.87513854,12.655539 8.44674326,11.4356158 C8.63281394,10.5975006 8.96601026,9.23789158 8.72368566,8.41374501 C8.53328776,7.10535411 7.00577732,7.26366475 6.7937433,8.09712372 C6.57738205,8.94920747 6.78076162,10.1644745 7.1572302,11.7196437 C6.64229042,13.0420032 5.87204437,14.8346384 5.33546846,15.8450328 C4.43540566,16.3432457 2.99443972,17.209298 2.79106014,18.2848792 C2.63960727,19.06712 3.78199468,20.1194201 5.08881664,18.5828757 C5.48259411,18.1219123 5.92397107,17.4281392 6.44323807,16.4643068 C7.59860715,16.0545616 8.87081131,15.5423801 9.9915626,15.3468199 C10.9392249,15.9055633 12.0513217,16.2734028 12.78695,16.2734028 C13.9855913,16.278059 14.037518,14.8672318 13.5874866,14.3829875 Z M3.66948683,18.5270013 C3.9247931,17.7866663 4.90707318,16.9252701 5.20565171,16.6272736 C4.24933498,18.2709106 3.66948683,18.5595947 3.66948683,18.5270013 Z M7.78900506,8.17627904 C8.16547363,8.17627904 8.12652861,9.9223523 7.87987678,10.392628 C7.65486108,9.63366819 7.66351553,8.17627904 7.78900506,8.17627904 Z M6.56007315,15.5935982 C7.04904957,14.6716716 7.4687904,13.5821218 7.80631396,12.6276018 C8.22605478,13.4517484 8.76263069,14.1036157 9.32516994,14.5599229 C8.27365426,14.7787641 7.36060978,15.2630084 6.56007315,15.5935982 Z M13.1980363,15.3188827 C13.1980363,15.3188827 12.9470573,15.6448164 11.3156935,14.8951689 C13.0898557,14.7554831 13.3797798,15.1931654 13.1980363,15.3188827 Z"
  />
);
const Powerpoint = () => (
  <path
    fill="currentColor"
    transform="translate(4.000000, 0.000000)"
    d="M16.0064054,4.56307145 L12.3758636,0.656523545 C11.9864133,0.237465963 11.4584919,0 10.9089343,0 L2.07706801,0 C0.930353382,0.00465619535 0,1.0057382 0,2.23962997 L0,21.6094026 C0,22.8432944 0.930353382,23.8443764 2.07706801,23.8443764 L14.5394761,23.8443764 C15.6861907,23.8443764 16.6165441,22.8432944 16.6165441,21.6094026 L16.6165441,6.14617787 C16.6165441,5.55484106 16.3958556,4.98212903 16.0064054,4.56307145 Z M15.0284525,5.62002779 C15.1193243,5.7178079 15.1799054,5.83421278 15.210196,5.96458625 L11.0776961,5.96458625 L11.0776961,1.51791969 C11.1988584,1.55051305 11.307039,1.61569979 11.3979107,1.71347989 L15.0284525,5.62002779 Z M14.5394761,22.3543939 L2.07706801,22.3543939 C1.69627221,22.3543939 1.38471201,22.0191478 1.38471201,21.6094026 L1.38471201,2.23962997 C1.38471201,1.82988477 1.69627221,1.49463871 2.07706801,1.49463871 L9.69298407,1.49463871 L9.69298407,6.33708188 C9.69298407,6.95635586 10.1559971,7.45456876 10.7315181,7.45456876 L15.2318321,7.45456876 L15.2318321,21.6094026 C15.2318321,22.0191478 14.9202719,22.3543939 14.5394761,22.3543939 Z M8.84052074,9.68954253 L6.05811504,9.68954253 C5.77251819,9.68954253 5.53884804,9.94097708 5.53884804,10.248286 L5.53884804,18.8156854 C5.53884804,19.1229943 5.77251819,19.3744289 6.05811504,19.3744289 L6.40429305,19.3744289 C6.6898899,19.3744289 6.92356005,19.1229943 6.92356005,18.8156854 L6.92356005,16.0033434 L8.84052074,16.0033434 C10.5151568,16.0033434 11.7700521,14.7322021 11.7700521,12.7905686 C11.7700521,10.9932772 10.7401725,9.68954253 8.84052074,9.68954253 Z M9.96559925,14.2386454 C9.64105737,14.5925162 9.19535319,14.7694517 8.62415949,14.7694517 L6.92356005,14.7694517 L6.92356005,10.8535914 L8.64146839,10.8535914 C9.19968042,10.8535914 9.64105737,11.0258706 9.96559925,11.3704291 C10.6276647,12.0735146 10.614683,13.5355599 9.96559925,14.2386454 Z"
  />
);

const Word = () => (
  <path
    fill="currentColor"
    transform="translate(4.000000, 0.000000)"
    d="M16.0064054,4.56307145 L12.3758636,0.656523545 C11.9864133,0.237465963 11.4584919,0 10.9089343,0 L2.07706801,0 C0.930353382,0.00465619535 0,1.0057382 0,2.23962997 L0,21.6094026 C0,22.8432944 0.930353382,23.8443764 2.07706801,23.8443764 L14.5394761,23.8443764 C15.6861907,23.8443764 16.6165441,22.8432944 16.6165441,21.6094026 L16.6165441,6.14617787 C16.6165441,5.55484106 16.3958556,4.98212903 16.0064054,4.56307145 Z M15.0284525,5.62002779 C15.1193243,5.7178079 15.1799054,5.83421278 15.210196,5.96458625 L11.0776961,5.96458625 L11.0776961,1.51791969 C11.1988584,1.55051305 11.307039,1.61569979 11.3979107,1.71347989 L15.0284525,5.62002779 Z M14.5394761,22.3543939 L2.07706801,22.3543939 C1.69627221,22.3543939 1.38471201,22.0191478 1.38471201,21.6094026 L1.38471201,2.23962997 C1.38471201,1.82988477 1.69627221,1.49463871 2.07706801,1.49463871 L9.69298407,1.49463871 L9.69298407,6.33708188 C9.69298407,6.95635586 10.1559971,7.45456876 10.7315181,7.45456876 L15.2318321,7.45456876 L15.2318321,21.6094026 C15.2318321,22.0191478 14.9202719,22.3543939 14.5394761,22.3543939 Z M12.2200835,10.8768723 C11.9258322,12.4041044 10.8137354,17.3815773 10.7747903,17.875134 C10.5238113,16.5201811 10.7444998,17.9496331 8.96601026,10.8489352 C8.90542911,10.606813 8.69772231,10.4345338 8.46405216,10.4345338 L8.18710976,10.4345338 C7.95343961,10.4345338 7.7457328,10.6021568 7.68515165,10.8489352 C6.02782447,17.4747012 6.06676949,17.3955458 5.98022499,18.0520694 C5.80280877,16.9392387 6.07109672,17.9170397 4.49165958,10.8629038 C4.43540566,10.6114692 4.22769885,10.4345338 3.98537425,10.4345338 L3.67381405,10.4345338 C3.3362905,10.4345338 3.08963867,10.7744361 3.17185595,11.1283069 C3.58294233,12.8976611 4.66474858,17.5259193 4.99794491,18.9507151 C5.05419884,19.1974934 5.26190564,19.3744289 5.49990301,19.3744289 L6.23553127,19.3744289 C6.46920142,19.3744289 6.67690822,19.2021496 6.73748937,18.9600275 C8.21740033,13.014066 8.18710976,13.2142824 8.32558096,12.3063243 C8.60685059,13.7544011 8.33423541,12.632258 9.91367255,18.9600275 C9.9742537,19.2021496 10.1819605,19.3744289 10.4156306,19.3744289 L11.0214422,19.3744289 C11.2594395,19.3744289 11.614272,19.2021496 11.6748531,18.9553713 L13.5269054,11.1329631 C13.6091227,10.7790922 13.3624709,10.4345338 13.0249473,10.4345338 L12.730696,10.4345338 C12.4840442,10.4345338 12.2720102,10.6207816 12.2200835,10.8768723 Z"
  />
);

const Spreadsheet = () => (
  <path
    fill="currentColor"
    transform="translate(4.000000, 0.000000)"
    d="M16.0064054,4.57105064 L12.376729,0.657805818 C11.9872788,0.237929764 11.4593573,0 10.9102325,0 L2.07663529,0 C0.930353382,0.00466528949 0,1.00770253 0,2.24353771 L0,21.6474097 C0,22.8832449 0.930353382,23.8862822 2.07663529,23.8862822 L14.5399088,23.8862822 C15.6861907,23.8862822 16.6165441,22.8832449 16.6165441,21.6474097 L16.6165441,6.15678253 C16.6165441,5.5647573 16.3958556,4.99092669 16.0064054,4.57105064 Z M11.0789942,1.52041784 C11.2001565,1.55307487 11.3083372,1.61838892 11.3992089,1.71636 L15.0288853,5.62960482 C15.119757,5.7275759 15.1803381,5.84420814 15.2106287,5.97483624 L11.0789942,5.97483624 L11.0789942,1.52041784 Z M15.2322648,21.6474097 C15.2322648,22.0579552 14.9207046,22.3938561 14.5399088,22.3938561 L2.07663529,22.3938561 C1.69583949,22.3938561 1.38427929,22.0579552 1.38427929,21.6474097 L1.38427929,2.24353771 C1.38427929,1.83299224 1.69583949,1.49289264 2.07663529,1.49289264 L9.69428224,1.49289264 L9.69428224,6.3480594 C9.69428224,6.96854291 10.1572953,7.46446318 10.7328162,7.46446318 L15.2322648,7.46446318 L15.2322648,21.6474097 Z M2.76942402,9.70380213 L2.76942402,20.1540506 C2.76942402,20.5664622 3.07925333,20.9004969 3.46178002,20.9004969 L13.1547641,20.9004969 C13.5372908,20.9004969 13.8471201,20.5664622 13.8471201,20.1540506 L13.8471201,9.70380213 C13.8471201,9.29139054 13.5372908,8.95735581 13.1547641,8.95735581 L3.46178002,8.95735581 C3.07925333,8.95735581 2.76942402,9.29139054 2.76942402,9.70380213 Z M12.4624081,19.4076043 L9.00062806,19.4076043 L9.00062806,17.1682653 L12.4624081,17.1682653 L12.4624081,19.4076043 Z M12.4624081,15.6753727 L9.00062806,15.6753727 L9.00062806,13.4360337 L12.4624081,13.4360337 L12.4624081,15.6753727 Z M4.15413603,10.4502484 L12.4624081,10.4502484 L12.4624081,11.9431411 L4.15413603,11.9431411 L4.15413603,10.4502484 Z M4.15413603,13.4360337 L7.61591605,13.4360337 L7.61591605,15.6753727 L4.15413603,15.6753727 L4.15413603,13.4360337 Z M4.15413603,17.1682653 L7.61591605,17.1682653 L7.61591605,19.4076043 L4.15413603,19.4076043 L4.15413603,17.1682653 Z"
  />
);
const Filter = () => (
  <path
    d="M19.19.75H.75l7.47 8.01v8.33l3.5-2.52V8.76L19.19.75z"
    style={{
      fill: 'none',
      // stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeWidth: '1.5px',
    }}
  />
);
const OpenedMessage = () => (
  <>
    <path
      d="m12 2.63-1.18 1.04h2.36L12 2.63zM2.81 10.72h2.67V8.37l-2.67 2.35zM18.52 8.37v-4.7h-5.34M18.52 8.37v1.96h2.67l-2.67-1.96z"
      style={{
        fill: 'none',
        // stroke: '#64748b',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
      }}
    />
    <path
      d="m12 16.22-6.15-5.55H2.81v10.7h18.38v-10.7h-3.04L12 16.22zM10.82 3.67H5.48v4.7M8.15 6.66h8.45M8.15 10.33h4.82M16.1 8.37h-2.59"
      style={{
        fill: 'none',
        // stroke: '#64748b',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
      }}
    />
  </>
);

const NewMessage = () => (
  <>
    <path
      d="M2.89 5.67H21.1v12.66H2.89z"
      style={{
        fill: 'none',
        // stroke: '#64748b',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.5px',
      }}
    />
    <path
      d="M12 13.04h0l9.11-7.37H2.89L12 13.04z"
      style={{
        fill: 'none',
        // stroke: '#64748b',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.5px',
      }}
    />
  </>
);
const Book = () => (
  <path
    d="m12.123 21.271h-0.21474c-0.06442-0.03288-0.12884-0.05479-0.19326-0.08767-1.5891-0.74521-3.2533-1.063-4.9927-1.0411-1.6213 0.02192-3.2103 0.33973-4.7672 0.78904-0.51537 0.15342-0.70864 0.06575-0.95559-0.40548v-14.466c0.16105-0.3726 0.44021-0.49315 0.82674-0.47123 0.37579 0.02192 0.76232 0 1.1381 0h0.38653v-1.8959c0-0.52603 0.15032-0.71233 0.65495-0.78904 0.42948-0.065754 0.85896-0.12055 1.2884-0.17534h0.81601c0.06442 0.010959 0.12884 0.021918 0.19326 0.032877 0.46169 0.065753 0.92338 0.087671 1.3851 0.1863 1.7072 0.36164 3.1889 1.1397 4.3055 2.5534 0.01074 0.02192 0.04295 0.03288 0.06442 0.05479 0.52611-0.63562 1.1274-1.1616 1.8253-1.5562 1.9863-1.1397 4.123-1.3699 6.3348-1.074 0.36506 0.043836 0.54758 0.28493 0.54758 0.66849v1.7534 0.2411h1.4924c0.52611 0 0.74085 0.21918 0.74085 0.75616v5.9397c0 2.663 0 5.337-0.01074 8 0 0.17534-0.05369 0.38356-0.16105 0.52603-0.18253 0.25206-0.45095 0.23014-0.71938 0.15342-1.4817-0.43836-2.9849-0.7452-4.531-0.8-1.9004-0.07671-3.7257 0.25206-5.4544 1.1068zm7.4192-5.063v-12.132c-1.9112-0.13151-3.7365 0.10959-5.3792 1.1945-0.5798 0.38356-1.063 0.86575-1.4495 1.4466-0.05368 0.08767-0.09663 0.21918-0.09663 0.31781v11.178c0 0.05479 0.01074 0.12055 0.02147 0.20822 2.1044-1.4247 4.327-2.389 6.9039-2.2137zm-8.1386 2.0932c0-0.08767 0.01074-0.13151 0.01074-0.17534v-11.134c0-0.09863-0.03221-0.21918-0.08589-0.30685-0.38654-0.65753-0.91265-1.1836-1.5461-1.589-1.3529-0.86575-2.8346-1.1616-4.3914-1.1178-0.27916 0.010959-0.54758 0.043836-0.84822 0.065753-0.02147 4.0877-0.04295 8.1425-0.06442 12.208 2.5339-0.06575 4.8316 0.53699 6.9253 2.0493zm-0.41874 1.2274c-0.07516-0.06575-0.15032-0.12055-0.23621-0.1863-2.0078-1.5014-4.284-2.0055-6.7321-1.8301-0.4939 0.03288-0.75159-0.19726-0.74085-0.71233 0.02147-3.2329 0.03221-6.4767 0.05368-9.7096v-0.25206h-1.0952v12.745c2.9204-0.76712 5.8302-0.99726 8.7506-0.0548zm9.7706-12.69v0.27397 9.6877c0 0.52603-0.26842 0.77808-0.77306 0.70137-0.77306-0.10959-1.5354-0.10959-2.3084 0.02192-1.5783 0.27397-2.9741 0.97534-4.2948 1.863-0.02147 0.02192-0.05369 0.04384-0.11811 0.10959 2.8775-0.88767 5.6906-0.64658 8.5037 0.08767v-12.745h-1.0093z"
    fill="currentColor"
    strokeWidth=".10847"
  />
);

const SafetyVest = () => (
  <path
    d="m3.2429 22.721v-11.511c0-0.1247 0.081762-0.23005 0.19451-0.26617 1.2578-0.50052 2.0458-1.3949 2.4055-2.6148 0.38815-1.3141 0.2909-3.0113-0.24098-5.0086-0.031414-0.12083 0.021086-0.24424 0.12178-0.30702l2.804-1.9423c0.13555-0.093309 0.23496-0.093739 0.36492-0.00688 0.91186 0.62737 2.0092 0.94126 3.1074 0.94126 1.1055 0 2.2102-0.3182 3.1255-0.95459a0.27941 0.2792 0 0 1 0.33436 0.01161l2.8268 1.9578a0.27799 0.27778 0 0 1 0.11102 0.30014c-0.53145 1.9973-0.62871 3.6945-0.24055 5.0086 0.36147 1.2251 1.1546 2.122 2.4219 2.6213 0.11016 0.043 0.17729 0.14835 0.17772 0.25972l4.3e-4 11.511a0.27971 0.2795 0 0 1-0.27971 0.2795h-16.955a0.27971 0.2795 0 0 1-0.27971-0.2795zm0.55899-9.5739h7.6848v2.7361h-7.6848v2.1121h7.6848v2.7361h-7.6848v1.7105h16.396v-1.7105h-7.6848v-2.7361h7.6848v-2.1121h-7.6848v-2.7361h7.6848v-1.7509c-1.337-0.58006-2.1818-1.5729-2.5764-2.9094-0.40451-1.3725-0.32576-3.1046 0.18805-5.1191l-2.276-1.5764c-0.21301 2.6634-1.334 4.8581-3.2623 6.6955a0.27885 0.27864 0 0 1-0.36664 0.01505c-2.0397-1.6374-2.9456-4.2505-3.3914-6.7432l-2.3233 1.609c0.51381 2.0145 0.59256 3.7466 0.18805 5.1191-0.39461 1.3364-1.2393 2.3293-2.5764 2.9094zm5.293-11.306c0.41483 2.2093 1.2243 4.555 2.9705 6.0694 1.7114-1.6976 2.7029-3.6984 2.9086-6.1072-0.90799 0.5074-1.9416 0.76152-2.974 0.76152-1.0065 0-2.0139-0.24166-2.9051-0.72368z"
    strokeWidth=".043016"
    fill="currentColor"
  />
);
// const Clock2 = () => (
//   <>
//     <path
//       d="m16.641 16-4.922-2.936V6.736"
//       stroke="currentColor"
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//     <path
//       d="M18.364 5.636A9 9 0 1 1 5.635 18.365 9 9 0 0 1 18.364 5.636"
//       stroke="currentColor"
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </>
// );
export const lineIconSizeVariants = [
  {
    variant: 'smaller',
    width: '16',
    height: '16',
  },
  {
    variant: 'small',
    width: '20',
    height: '20',
  },
  {
    variant: 'default',
    width: '24',
    height: '24',
  },
  {
    variant: 'medium',
    width: '28',
    height: '28',
  },
  {
    variant: 'large',
    width: '32',
    height: '32',
  },
  {
    variant: 'larger',
    width: '48',
    height: '48',
  },
  {
    variant: 'largest',
    width: '72',
    height: '72',
  },
  {
    variant: 'extraLarge',
    width: '115',
    height: '115',
  },
];

export const getIconColor = (color, {colors}) => {
  switch (color) {
    case 'white':
      return colors.white;
    case 'grey[5]':
    case 'greyDark':
      return colors.grey[5];
    case 'grey[4]':
    case 'grey':
      return colors.grey[4];
    case 'grey[3]':
    case 'greyLight':
      return colors.grey[3];
    case 'whatsapp':
      return colors.whatsapp;
    case 'none':
      return 'none';
    default:
      return color.startsWith('#') ? color : colors.primary;
  }
};

export const StyledSvg = styled.svg`
  ${space}
`;

const Icon = ({
  name,
  size = 'default',
  color = 'default',
  noStroke,
  ...props
}) => {
  const theme = useTheme();
  const sizeStyles = lineIconSizeVariants.find(whereVariant(size));
  const iconColor = getIconColor(color, theme);
  return (
    <StyledSvg
      viewBox="0 0 24 24"
      fill="none"
      color={iconColor}
      stroke={noStroke ? 'transparent' : iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={noStroke ? 0 : 1.5}
      {...sizeStyles}
      {...props}>
      {(() => {
        switch (name) {
          case 'android':
            return <Android />;
          case 'apple':
            return <Apple />;
          case 'arrowBackUp':
            return <ArrowBackUp />;
          case 'arrowLeft':
            return <ArrowLeft />;
          case 'bin':
            return <Bin />;
          case 'bookmark':
            return <Bookmark />;
          case 'box':
            return <Box />;
          case 'calendar':
            return <Calendar />;
          case 'calendarAdd':
            return <CalendarAdd />;
          case 'chat':
            return <Chat />;
          case 'cheer':
            return <Cheer />;
          case 'chevronLeft':
            return <ChevronLeft />;
          case 'chevronLeftLarge':
            return <ChevronLeftLarge />;
          case 'chevronRight':
            return <ChevronRight />;
          case 'comments':
            return <Comments />;
          case 'cross':
            return <Cross />;
          case 'document':
            return <Document />;
          case 'download':
            return <Download />;
          case 'email':
            return <Email />;
          case 'error':
            return <Error />;
          case 'folder':
            return <Folder />;
          case 'folders':
            return <Folders />;
          case 'home':
            return <Home />;
          case 'image':
            return <Image />;
          case 'info':
            return <Info />;
          case 'link':
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            return <Link />;
          case 'magnifier':
            return <Magnifier />;
          case 'menuDots':
            return <MenuDots />;
          case 'microsoft':
            return <Microsoft />;
          case 'mobilePhone':
            return <MobilePhone />;
          case 'noSearch':
            return <NoSearch />;
          case 'pen':
            return <Pen />;
          case 'phone':
            return <Phone />;
          case 'privacy':
            return <Privacy />;
          case 'play':
            return <Play />;
          case 'settings':
            return <Settings />;
          case 'star':
            return <Star />;
          case 'success':
            return <Success />;
          case 'tools':
            return <Tools />;
          case 'user':
            return <User />;
          case 'users':
            return <Users />;
          case 'whatsapp':
            return <WhatsApp />;
          case 'inbox':
            return <Inbox />;
          case 'clock':
            return <Clock />;
          case 'marker':
            return <Marker />;
          case 'upload':
            return <Upload />;
          case 'idea':
            return <IdeaIcon />;
          case 'adminInbox':
            return <AdminInboxIcon />;
          case 'anonymous':
            return <AnonymousIcon />;
          case 'addMessageIcon':
            return <AddMessageIcon />;
          case 'word':
            return <Word />;
          case 'excel':
          case 'spreadsheet':
            return <Spreadsheet />;
          case 'powerpoint':
            return <Powerpoint />;
          case 'pdf':
            return <Pdf />;
          case 'newMessage':
          case 'unopenedMessage':
            return <NewMessage />;
          case 'openedMessage':
            return <OpenedMessage />;
          case 'filter':
            return <Filter />;
          case 'book':
            return <Book />;
          case 'safetyVest':
            return <SafetyVest />;
          default:
            return null;
        }
      })()}
    </StyledSvg>
  );
};

export default Icon;
